export enum GroupChoiceKey {
  SelectFromExistingBots = 'SelectFromExistingBots',
  ConnectToDifferentBot = 'ConnectToDifferentBot',
}

export const onActivate = (
  handler: (e: React.MouseEvent | React.KeyboardEvent) => void
) => ({
  onClick: (e: React.MouseEvent<HTMLElement>) => {
    handler(e);
  },
  onKeyDown: (e: React.KeyboardEvent<HTMLElement>) => {
    e.stopPropagation();
    if (e.key === 'Enter' || e.key === ' ') {
      handler(e);
    }
  },
  tabIndex: 0,
});
